import { AHOC_REFERENCE_DATA_SET_VALUE } from "../../actions/allsureHomeClaim/referenceData";


export const initReferenceData= {
  apiStatus: null,
  referenceNumber: null,
};

export default (state = initReferenceData, action) => {
    
  switch (action.type) {
    case AHOC_REFERENCE_DATA_SET_VALUE:
      return {
        ...state,
        [action.value.type]: action.value.value,
      };
    
    default:
      return state;
  }
};

